import { useState } from "react";
import { faqs } from "@/mocks/kuaibao";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-6 h-[3px] rounded-full bg-primary-500"></span>
              <span className="font-label text-xs tracking-[0.2em] text-primary-600">
                FAQ
              </span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug mb-4">
              关于吃瓜单，你可能想知道
            </h2>
            <p className="font-label text-sm text-foreground-500 leading-relaxed">
              这里是关于内容更新、筛选原则和反馈方式的最常见问题。
              没找到答案的话，页面底部随时可以联系我们。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3.5 py-2 rounded-md bg-primary-100 text-primary-800 font-label text-xs">
              <i className="ri-customer-service-2-line leading-none"></i>
              平均 1 个工作日内回复反馈
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, i) => {
                const isOpen = open === i;
                return (
                  <article
                    key={item.q}
                    className="bg-background-50 border border-background-200/80 rounded-lg overflow-hidden"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : i)}
                        className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                        aria-expanded={isOpen}
                      >
                        <span className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i
                            className={`${
                              isOpen ? "ri-subtract-line" : "ri-add-line"
                            } text-base leading-none`}
                          ></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                        <p className="font-label text-sm text-foreground-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}